import { AsyncPipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { CurrentProductService, ProductDetailOutlets } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { ComponentService } from 'src/app/service/component.service';
import { SnahCountryService, WAREHOUSE } from 'src/app/service/snah/snah-countries.service';
import { ProductLeadTime as Product } from '../../../../model/product.model';

@Component({
  selector: 'app-product-stock-info',
  templateUrl: './product-stock-info.component.html',
  styleUrls: ['./product-stock-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated,
  providers: [AsyncPipe],
  standalone: false,
})
export class ProductStockInfoComponent implements OnInit, OnDestroy, AfterViewInit {
  outlets = ProductDetailOutlets;
  isDiscontinuedSubscription$: Subscription;
  isDiscontinued: boolean;
  showDiv: boolean = false;

  product$: Observable<Product> = this.currentProductService.getProduct();
  showWarehouseFeature$: Observable<boolean> = this.SnahCountryService.getSnahFeatures(WAREHOUSE);

  constructor(
    protected currentProductService: CurrentProductService,
    protected componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private SnahCountryService: SnahCountryService,
    private pipeAsync: AsyncPipe
  ) {}

  ngOnInit(): void {
    this.isDiscontinuedSubscription$ = this.componentService.isDiscontinued$.subscribe((isDiscontinued) => {
      isDiscontinued ? (this.isDiscontinued = isDiscontinued) : false;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.showDiv = !this.showDiv ? true : false;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    }, 500);
  }

  checkSalesRepStockData(salesRepStockData: any, isSnahCountry: boolean) {
    let finalStocks = [];
    const numbeOfWarehouseDisplay = isSnahCountry ? 10 : 2;
    const stocks = salesRepStockData.slice(0, numbeOfWarehouseDisplay);

    if (stocks.length > 0) {
      if (stocks.every((item: any) => item.stockLevelStatus === 'outOfStock')) {
        finalStocks = isSnahCountry ? stocks : stocks.slice(0, 1);
      } else if (stocks.every((item: any) => item.stockLevelStatus === 'discontinued')) {
        finalStocks = stocks.slice(0, 1);
      } else {
        let status: string = isSnahCountry ? 'discontinued' : 'outOfStock';
        finalStocks = stocks.filter((item: any) => item.stockLevelStatus !== status);
      }
    }
    return finalStocks;
  }

  salesRepStockData(salesRepStockData: any) {
    if (salesRepStockData) {
      if (salesRepStockData.length < 1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  checkStockLevel(stockLevel: string, isSnahCountry: boolean): string {
    if (isSnahCountry) {
      return parseInt(stockLevel) > 100 ? '100+' : stockLevel;
    } else {
      return stockLevel;
    }
  }
  addOverlay(productVaraintLength: number, isDiscontinued: boolean) {
    const productStockInfo = document.querySelector('app-product-stock-info');
    if ((this.isDiscontinued && productVaraintLength <= 1) || isDiscontinued) {
      productStockInfo.classList.add('overlay-error-msg');
    }
  }

  ngOnDestroy() {
    this.isDiscontinuedSubscription$?.unsubscribe();
  }
}
